import React from "react";
import {titleCodes, textCodes} from '../../template_codes/asteria/contact_page_codes';

function Contact() {
    return (
        <React.Fragment>
            <div className="py-20 lg:text-center xl:text-center pl-10">
                <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold pb-10">{titleCodes.contact.title}</h1>
                <ul className="list-none">
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{titleCodes.email.title}</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.emailText.text}</p>
                    </li>
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{titleCodes.phone.title}</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.phoneNumber.text}</p>
                    </li>
                    <li className="pb-8">
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{titleCodes.location.title}</p>
                        <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.locationText.text}</p>
                    </li>
                </ul>
            </div>
        </React.Fragment>
    );
}

export default Contact;

// import { Container, Text } from "@mantine/core";
// import React from "react";

// const ContactPage = () => {
//   return (
//     <Container my={"xl"}>
//       <Text className="text-3xl text-center italic font-semibold">Contact Us</Text>
//     </Container>
//   );
// };

// export default ContactPage;
